/* POP US! — World-Class impact layer: sticky-header elevation + scroll reveal.
   Header elevation runs always; reveal is motion-only and gated by `.pu-js`
   (nothing is hidden unless JS confirms support). Includes a safety timeout. */
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Sticky header elevation on scroll (independent of reduced-motion) */
  var header = document.querySelector('store-header.header');
  if (header) {
    var ticking = false;
    var onScroll = function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          header.classList.toggle('pu-scrolled', window.scrollY > 12);
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Scroll reveal (motion only) */
  if (reduce || !('IntersectionObserver' in window)) return;
  root.classList.add('pu-js');

  function setup() {
    var sections = Array.prototype.slice.call(document.querySelectorAll('.shopify-section'));
    // Skip the first section (hero) to avoid any above-the-fold flash.
    sections.slice(1).forEach(function (el) { el.classList.add('pu-reveal'); });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('pu-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.04 });

    document.querySelectorAll('.pu-reveal').forEach(function (el) { io.observe(el); });

    // Safety net: never leave content stuck hidden.
    setTimeout(function () {
      document.querySelectorAll('.pu-reveal:not(.pu-in)').forEach(function (el) {
        el.classList.add('pu-in');
      });
    }, 3500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
})();

/* ---- Collection: on-demand "Load more" (append products) ----
   Replaces the numbered prev/next pagination on collection pages. The initial page
   stays light (only the first page of products in the DOM); more load ONLY when the
   shopper clicks "Load more" — no auto/infinite scroll. Re-inits after facet/sort. */
(function () {
  function init() {
    var pagination = document.querySelector('.collection__pagination');
    var list = document.querySelector('product-list.product-list');
    if (!pagination || !list || pagination.dataset.puLoadmore) return;
    pagination.dataset.puLoadmore = '1';

    var nextLink = pagination.querySelector('a[rel="next"]');
    var nextUrl = nextLink ? nextLink.getAttribute('href') : null;

    pagination.style.display = 'none';

    var wrap = document.createElement('div');
    wrap.className = 'pu-loadmore';
    pagination.parentNode.insertBefore(wrap, pagination.nextSibling);
    if (!nextUrl) return; // single page — just hide the numbered nav

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'button button--outline pu-loadmore__btn';
    btn.textContent = 'Load more';
    wrap.appendChild(btn);

    var loading = false;

    function load() {
      if (loading || !nextUrl) return;
      loading = true;
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = 'Loading…';
      fetch(nextUrl).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newList = doc.querySelector('product-list.product-list');
        if (newList) {
          var frag = document.createDocumentFragment();
          Array.prototype.slice.call(newList.children).forEach(function (node) {
            frag.appendChild(document.importNode(node, true));
          });
          list.appendChild(frag);
        }
        var np = doc.querySelector('.collection__pagination a[rel="next"]');
        nextUrl = np ? np.getAttribute('href') : null;
        loading = false;
        btn.removeAttribute('aria-busy');
        if (nextUrl) { btn.textContent = 'Load more'; }
        else { wrap.innerHTML = '<p class="pu-loadmore__end">You’ve reached the end</p>'; }
      }).catch(function () {
        loading = false; btn.removeAttribute('aria-busy'); btn.textContent = 'Load more';
      });
    }

    btn.addEventListener('click', load);
  }

  function boot() {
    init();
    if (window.MutationObserver) {
      new MutationObserver(function () {
        var pag = document.querySelector('.collection__pagination');
        if (pag && !pag.dataset.puLoadmore) init();
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* ---- Hero Drop Board: post-load entrance (Zone 2 only) + real countdown ----
   The Zone 1 product image is never touched here — it's the LCP element and
   stays fully static. Everything below only affects the fade-in of the label/
   title/CTA and the countdown digits. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealContent() {
    var drop = document.querySelector('.pu-drop');
    if (!drop) return;
    var content = drop.querySelector('.pu-drop__content');

    if (reduce || !content) {
      drop.classList.add('pu-drop--ready');
      return;
    }

    content.style.willChange = 'opacity, transform';

    var revealed = false;
    function reveal() {
      if (revealed) return;
      revealed = true;
      drop.classList.add('pu-drop--ready');

      var cleared = false;
      function clearWillChange() {
        if (cleared) return;
        cleared = true;
        content.style.willChange = '';
        content.removeEventListener('transitionend', clearWillChange);
      }
      content.addEventListener('transitionend', clearWillChange);
      // Safety net in case transitionend never fires (e.g. display changes elsewhere).
      window.setTimeout(clearWillChange, 900);
    }

    // Double rAF: wait a frame for style application, then trigger the
    // transition on the next one — runs after `load`, well past LCP.
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(reveal);
    });
    // Safety net: rAF never fires for a tab that loads while backgrounded/
    // hidden (browsers suspend it), which would otherwise leave Zone 2
    // stuck at opacity:0 forever. Guarantee visibility within a bounded time.
    window.setTimeout(reveal, 400);
  }

  if (document.readyState === 'complete') revealContent();
  else window.addEventListener('load', revealContent);

  /* ---- Countdown: only runs if the server actually rendered one, which only
     happens when a real future end-date was configured (see pu-hero-drop.liquid).
     No countdown element in the DOM = nothing to do here. ---- */
  function initCountdown() {
    var el = document.querySelector('.pu-drop__countdown[data-end]');
    if (!el) return;

    var endMs = Date.parse(el.getAttribute('data-end'));
    if (!endMs || isNaN(endMs)) { el.remove(); return; }

    var nums = {
      d: el.querySelector('[data-unit="d"]'),
      h: el.querySelector('[data-unit="h"]'),
      m: el.querySelector('[data-unit="m"]'),
      s: el.querySelector('[data-unit="s"]')
    };
    var srNode = el.querySelector('.pu-drop__countdown-sr');
    var lastAnnounced = null;
    var timerId = null;

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function setNum(node, value) {
      if (!node || node.textContent === value) return;
      node.textContent = value;
      if (!reduce) {
        node.classList.add('pu-tick');
        window.setTimeout(function () { node.classList.remove('pu-tick'); }, 200);
      }
    }

    function tick() {
      var diff = endMs - Date.now();

      if (diff <= 0) {
        window.clearInterval(timerId);
        el.setAttribute('hidden', '');
        return;
      }

      var totalSeconds = Math.floor(diff / 1000);
      var d = Math.floor(totalSeconds / 86400);
      var h = Math.floor((totalSeconds % 86400) / 3600);
      var m = Math.floor((totalSeconds % 3600) / 60);
      var s = totalSeconds % 60;

      setNum(nums.d, String(d));
      setNum(nums.h, pad(h));
      setNum(nums.m, pad(m));
      setNum(nums.s, pad(s));

      if (srNode) {
        var announced = d + ':' + h;
        if (announced !== lastAnnounced) {
          lastAnnounced = announced;
          srNode.textContent = d + ' days ' + h + ' hours remaining';
        }
      }
    }

    tick();
    timerId = window.setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCountdown);
  else initCountdown();
})();
